import React, { useState } from 'react';
import Navbar from '../Components/Header';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
const BlogPostCreator = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [blogType, setBlogType] = useState('');
  const [author, setAuthor] = useState('');
  const [readTime, setReadTime] = useState('');
  const [image, setImage] = useState(null);
  const [sections, setSections] = useState([{ heading: '', text: '', image: null }]);
  const [token,setToken] =useState(localStorage.getItem('token'));
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // base64 representation
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSectionImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updatedSections = [...sections];
        updatedSections[index].image = reader.result; // base64 representation
        setSections(updatedSections);
      };
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {
    const checkToken = async () => {
      try {
        const response = await axios.post('http://localhost:5000/api/verify', null, {
          headers: {
            auth: token,
          },
        });
        response.data.message === 'Verified' ? console.log('Token verified') : console.log('Token not verified');
      } catch (error) {
        console.error('Error verifying token:', error);
        navigate('/login');
      }
    };
    checkToken();
  }
  , [token]);

  

  const addSection = () => {
    setSections([...sections, { heading: '', text: '', image: null }]);
  };

  const updateSection = (index, field, value) => {
    const updatedSections = [...sections];
    updatedSections[index][field] = value;
    setSections(updatedSections);
  };

  const removeSection = (index) => {
    const updatedSections = sections.filter((_, i) => i !== index);
    setSections(updatedSections);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const blogPostData = {
      title,
      description,
      blogType,
      author,
      readTime,
      image, // Base64 encoded image
      sections,
    };
    const config = {
      headers: {
        "token": token,
      },
    };

    try {
      const response = await axios.post('http://localhost:5000/api/blogs', blogPostData,config);
      console.log('Blog post created:', response.data);
      alert('Blog post created successfully!');
      // Clear the form after submission (optional)
      setTitle('');
      setDescription('');
      setBlogType('');
      setAuthor('');
      setReadTime('');
      setImage(null);
      setSections([{ heading: '', text: '', image: null }]);
    } catch (error) {
      console.error('Error creating blog post:', error);
    }
  };

  return (
    <div className='bg-white mb-4'>
      <div className='w-full mb-5'>
        <Navbar />
      </div>
      <div className="max-w-2xl mx-auto px-10   p-6 space-y-8 bg-white border-2 border-teal-600 rounded-3xl shadow-lg">
        <h1 className="text-3xl font-bold mb-6 text-center text-teal-800">Create a Blog Post</h1>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-2 text-teal-700" htmlFor="image">
              Upload Image
            </label>
            <input
              id="image"
              type="file"
              onChange={handleImageChange}
              accept="image/*"
              className="file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100"
            />
            {image && (
              <img src={image} alt="Preview" className="mt-4 max-w-full h-48 object-cover rounded-2xl shadow-md" />
            )}
          </div>

          <div>
            <label className="block text-sm font-medium mb-2 text-teal-700" htmlFor="title">
              Main Title
            </label>
            <input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter main title"
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-full"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2 text-teal-700" htmlFor="description">
              Short Description
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter short description"
              rows={3}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-2xl"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2 text-teal-700" htmlFor="blogType">
              Blog Type
            </label>
            <select
              id="blogType"
              value={blogType}
              onChange={(e) => setBlogType(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-full"
            >
              <option value="">Select blog type</option>
              <option value="tech">Technology</option>
              <option value="lifestyle">Lifestyle</option>
              <option value="travel">Travel</option>
              <option value="food">Food</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2 text-teal-700" htmlFor="author">
              Author
            </label>
            <input
              id="author"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
              placeholder="Enter author name"
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-full"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2 text-teal-700" htmlFor="readTime">
              Approximate Read Time (in minutes)
            </label>
            <input
              id="readTime"
              type="number"
              value={readTime}
              onChange={(e) => setReadTime(e.target.value)}
              placeholder="Enter read time"
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-full"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-xl font-semibold text-teal-800">Sections</h2>
            {sections.map((section, index) => (
              <div key={index} className="p-6 bg-white rounded-2xl shadow-md relative">
                <button
                  type="button"
                  className="absolute top-3 right-3 text-gray-400 hover:text-teal-600"
                  onClick={() => removeSection(index)}
                >
                  X
                </button>
                <input
                  value={section.heading}
                  onChange={(e) => updateSection(index, 'heading', e.target.value)}
                  placeholder="Section Heading (optional)"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-full mb-3"
                />
                <textarea
                  value={section.text}
                  onChange={(e) => updateSection(index, 'text', e.target.value)}
                  placeholder="Section Text"
                  rows={4}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-2xl"
                />
                <div className="mt-4">
                  <label className="block text-sm font-medium mb-2 text-teal-700">
                    Upload Section Image
                  </label>
                  <input
                    type="file"
                    onChange={(e) => handleSectionImageChange(index, e)}
                    accept="image/*"
                    className="file:mr-4 file:py-2 file:px-4 file:rounded-full"
                  />
                  {section.image && (
                    <img src={section.image} alt="Section Preview" className="mt-4 max-w-full h-48 object-cover rounded-2xl shadow-md" />
                  )}
                </div>
              </div>
            ))}
             <button
            type="submit"
            className="w-full py-3 bg-teal-600 text-white rounded-full hover:bg-teal-700" onClick={addSection}
          >
            Add Section
          </button>
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-teal-600 text-white rounded-full hover:bg-teal-700"
          >
            Create Blog Post
          </button>
        </form>
      </div>
    </div>
  );
};

export default BlogPostCreator;